import { bl_fi_item_view_hdr_RowClass } from '../../dbschema/bl_fi_item_view_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class FiItemViewContainerModel extends BaseContainerModel {
    bl_fi_item_view_hdr: bl_fi_item_view_hdr_RowClass = new bl_fi_item_view_hdr_RowClass();
}
